module.exports = __webpack_public_path__ + "static/media/Icon-filter.aea11ab8.png";